<!--
 * @Author: Lemon C
 * @Date: 2024-05-14 12:11:25
 * @LastEditTime: 2025-03-14 16:33:07
-->
<template>
    <div class="sup-faq-comp" @mousemove="listen_mouse_move" @mouseup="listen_mouse_up">
        <div class="faq-left-box" ref="ref_faq_left_box">
            <DocsBreadcrumb ref="ref_breadcrumb" class="content-breadcrumb"></DocsBreadcrumb>
            <div class="faq-list-box" v-if="faq_list.length">
                <div
                    :class="`list-item-box ${faq_sel_item && faq_sel_item.id === item.id ? 'list-item-box-active' : ''}`"
                    v-for="(item, index) in faq_list"
                    :key="index"
                    :id="item.id"
                    @click="item_faq_click(item)">
                    <div class="item-circle"></div>
                    <span class="item-title">{{ item.title }}</span>
                </div>
            </div>
            <el-empty class="faq-list-box" v-else description="暂无问题" />
        </div>
        <div class="faq-split-box">
            <div class="split-line"></div>
            <div class="slide-box" @mousedown="listen_mouse_down">
                <el-icon><CaretLeft /></el-icon>
                <el-icon><CaretRight /></el-icon>
            </div>
        </div>
        <div class="faq-content-box" ref="ref_faq_content_box" v-if="faq_sel_item && faq_sel_item.title.length">
            <div class="top-box">
                <span class="md-second-title" v-if="faq_sel_item.title && faq_sel_item.title.length">{{ faq_sel_item.title }}</span>
                <span class="last-update-time" v-if="last_update_time_computed.length">{{ last_update_time_computed }}</span>
            </div>
            <div class="content-md" @click="md_handle_link_click">
                <md-preview :editorId="md_preview_id" :modelValue="faq_sel_item.content" previewTheme="github" :codeFoldable="false" />
            </div>
        </div>
        <el-empty class="faq-content-empty-box" v-else description="暂无问题详情" />
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch, getCurrentInstance, nextTick, computed } from 'vue';
import DocsBreadcrumb from '@/components/Docs/DocsBreadcrumb.vue';
import { MdPreview } from 'md-editor-v3';
import 'md-editor-v3/lib/preview.css';
import { formatTime } from '@/utils/generalMethods';
import { getDocumentListByDcId } from '@/service/interface';
import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '../../stores/message';

const router_store = useRouterStore();
const message_store = useMessageStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    comp_tree_node_id: String,
    comp_sel_faq_list_id: String,
});

const md_preview_id = ref('preview-only');
const ref_faq_left_box = ref(null);
const ref_faq_content_box = ref(null);
const ref_faq_content_empty_box = ref(null);
const faq_list = ref([]);
const faq_sel_item = ref(null);
const mouseDown = ref(false); //鼠标按下
const mouseDownX = ref(0); //鼠标移动x坐标
const leftBoxWidth = ref(0); //左侧宽度
const contentBoxWidth = ref(0); //内容宽度

watch(
    () => props.comp_tree_node_id,
    (val) => {
        faq_sel_item.value = null;
        service_get_faq();
    }
);

const last_update_time_computed = computed(() => {
    let timeStr = '';
    if (faq_sel_item.value.creationTime && faq_sel_item.value.creationTime.length > 0) {
        timeStr = '最后更新于 ' + formatTime(faq_sel_item.value.creationTime);
    }
    if (faq_sel_item.value.lastModificationTime && faq_sel_item.value.lastModificationTime.length > 0) {
        timeStr = '最后更新于 ' + formatTime(faq_sel_item.value.lastModificationTime);
    }
    return timeStr;
});

onMounted(() => {
    service_get_faq();
});

// MARK Service  获取faq信息
const service_get_faq = () => {
    if (!props.comp_tree_node_id || !props.comp_tree_node_id.length) {
        return;
    }
    let params = {
        dcid: props.comp_tree_node_id,
    };
    proxy.$showLoading();
    getDocumentListByDcId({ params }).then((res) => {
        proxy.$hideLoading();
        let result = res.data;
        if (res.isSuccess && Object.keys(result).length !== 0) {
            faq_list.value = result;
            scroll_auto_loc();
        } else {
            faq_list.value = [];
        }
    });
};
// MARK Scroll 自动定位
const scroll_auto_loc = () => {
    if (props.comp_sel_faq_list_id.length !== 0) {
        let faq_item = faq_list.value.find((item) => item.id === props.comp_sel_faq_list_id);
        if (faq_item) {
            item_faq_click(faq_item);
            nextTick(() => {
                const element = document.getElementById(props.comp_sel_faq_list_id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
    } else {
        let faq_item = faq_list.value.length > 0 ? faq_list.value[0] : null;
        if (faq_item) {
            item_faq_click(faq_item);
        }
    }
};
// MARK Click  faq点击
const item_faq_click = (item) => {
    nextTick(() => {
        faq_sel_item.value = item;
    });
};
// MARK 监听  鼠标按下
const listen_mouse_down = (e) => {
    mouseDown.value = true;
    mouseDownX.value = e.clientX;
    if (ref_faq_left_box.value) leftBoxWidth.value = ref_faq_left_box.value.clientWidth;
    if (ref_faq_content_box.value) contentBoxWidth.value = ref_faq_content_box.value.clientWidth;
    if (ref_faq_content_empty_box.value) contentBoxWidth.value = ref_faq_content_empty_box.value.clientWidth;
    // console.log('before  leftBoxWidth: ', leftBoxWidth.value);
    // console.log('before  contentBoxWidth: ', contentBoxWidth.value);
};
// MARK 监听  鼠标移动
const listen_mouse_move = (e) => {
    if (!mouseDown.value) return false;
    let deltaX = e.clientX - mouseDownX.value;
    if (leftBoxWidth.value + deltaX < 200 || leftBoxWidth.value + deltaX > 600) {
        return; // 限制最小/最大的拖动范围
    }
    if (ref_faq_left_box.value) ref_faq_left_box.value.style.width = `${leftBoxWidth.value + deltaX}px`;
    if (ref_faq_content_box.value) ref_faq_content_box.value.style.width = `${contentBoxWidth.value - deltaX}px`;
    if (ref_faq_content_empty_box.value) ref_faq_content_empty_box.value.style.width = `${contentBoxWidth.value - deltaX}px`;
    // console.log('move  deltaX: ', deltaX);
    // console.log('move  leftBoxWidth: ', leftBoxWidth.value);
    // console.log('move  contentBoxWidth: ', contentBoxWidth.value);
};
// MARK 监听  鼠标抬起
const listen_mouse_up = () => {
    mouseDown.value = false;

    if (ref_faq_left_box.value) ref_faq_left_box.value.style.zIndex = 'auto';
    if (ref_faq_content_box.value) ref_faq_content_box.value.style.pointerEvents = 'auto';
    if (ref_faq_content_empty_box.value) ref_faq_content_empty_box.value.style.pointerEvents = 'auto';
};

// MARK MD 处理链接点击
const md_handle_link_click = (event) => {
    const target = event.target;
    if (target.tagName === 'A') {
        event.preventDefault(); // 阻止默认的链接跳转行为
        const href = target.getAttribute('href');
        router_store.navigateToLinkHref(href, (query) => {
            message_store.sendMessage(message_store.M_E_TREE_AUTO_SEL, { treeId: query.treeId });
        });
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-faq-comp {
    position: relative;
    overflow: hidden;
    display: flex;

    .faq-left-box {
        position: relative;
        width: 500px;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        overflow: hidden;
        box-sizing: border-box;
        padding-right: 10px;
        box-sizing: border-box;

        .content-breadcrumb {
            position: relative;
            padding-top: 22px !important;
            padding-left: 23px !important;
        }

        .faq-list-box {
            position: relative;
            width: 100%;
            flex: 1;
            overflow-y: auto;

            .list-item-box {
                position: relative;
                margin-left: 20px;
                margin-right: 16px;
                margin-top: 16px;
                height: 50px;
                background: var(--color-main-tree-cell-bg-default);
                border-radius: 2px;
                padding: 0 20px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                cursor: pointer;

                .item-circle {
                    position: relative;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: var(--color-main-brand);
                    flex-shrink: 0;
                }

                .item-title {
                    position: relative;
                    margin-left: 8px;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--color-main-text-primary);
                    line-height: 24px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                &:hover {
                    background: var(--color-main-brand-hover-light);

                    .item-title {
                        color: var(--color-main-brand);
                    }
                }
            }

            .list-item-box-active {
                background: var(--color-main-brand-hover-light);

                .item-title {
                    color: var(--color-main-brand);
                }
            }
        }
    }

    .faq-split-box {
        position: relative;
        width: 10px;
        height: 100%;
        display: flex;
        justify-content: center;

        .split-line {
            position: relative;
            width: 1px;
            height: 100%;
            background: var(--color-main-doc-segmentation-line-bg);
        }

        .slide-box {
            position: absolute;
            top: 250px;
            left: 0;
            width: 10px;
            height: 40px;
            background: var(--color-main-light-bg);
            border-radius: 10px;
            border: 1px solid var(--color-main-border-gray);
            cursor: col-resize;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: var(--color-main-text-secondary);
            font-size: 12px;
        }
    }

    .faq-content-empty-box {
        position: relative;
        margin-top: 50px;
        flex: 1;
        display: flex;
    }

    .faq-content-box {
        position: relative;
        flex: 1;
        height: 100%;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .top-box {
            position: relative;
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
            padding: 25px 20px;
            box-sizing: border-box;

            .md-second-title {
                position: relative;
                color: var(--color-main-text-primary);
                font-size: 30px;
                font-weight: 600;
                line-height: 38px;
            }
            .last-update-time {
                position: relative;
                display: flex;
                align-items: center;
                margin-top: 5px;
                color: var(--color-main-text-secondary);
                font-size: 14px;
                font-variant: tabular-nums;
                line-height: 1.66667;
            }
        }

        :deep(.content-md) {
            position: relative;
            margin-right: 27px;
            display: flex;
            width: 100%;
            height: 100%;
            overflow: hidden;

            .md-editor-code-head {
                background-color: var(--color-main-md-code-bg) !important;
            }
            .md-editor-code pre code {
                background-color: var(--color-main-md-code-bg) !important;
            }
            .md-editor ::-webkit-scrollbar {
                width: var(--scrollbar-width);
            }

            .md-editor ::-webkit-scrollbar-track {
                background-color: var(--color-main-scrollbar-track-white);
                border-radius: unset;
            }

            .md-editor ::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background-color: var(--color-main-scrollbar-thumb);
                box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
                -webkit-box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
            }
        }
    }
}
</style>
